export default {
}



// WEBPACK FOOTER //
// ./src/store/contactus/getters.js